module.exports = __webpack_public_path__ + "img/XLS.b1311f4f.png";